import React from 'react';

export default function AnnouncementBanner({ announcements = [], onDismiss }) {
  if (!announcements.length) {
    return null;
  }

  return (
    <div className="pfp-news-banner-wrap">
      {announcements.map((item) => (
        <div key={item.id} className={`pfp-news-banner pfp-news-banner--${item.type || 'info'}`}>
          <div className="pfp-news-banner__content">
            <strong>{item.title}</strong>
            <div dangerouslySetInnerHTML={{ __html: item.message }} />
          </div>

          <div className="pfp-news-banner__actions">
            {item.cta_label && item.cta_url && (
              <a className="pfand-button pfand-button--secondary" href={item.cta_url}>
                {item.cta_label}
              </a>
            )}
            <button type="button" className="pfand-button" onClick={() => onDismiss(item.id)}>
              Schließen
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
